/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */
export var ActionExecType;
(function (ActionExecType) {
    ActionExecType["auto"] = "auto";
    ActionExecType["manual"] = "manual";
})(ActionExecType || (ActionExecType = {}));
export var ActionKey;
(function (ActionKey) {
    ActionKey["addCommentRow"] = "addCommentRow";
    ActionKey["addComputationListParam"] = "addComputationListParam";
    ActionKey["addFunctionToGraph"] = "addFunctionToGraph";
    ActionKey["addGraphRow"] = "addGraphRow";
    ActionKey["addRow"] = "addRow";
    ActionKey["copyToNewRow"] = "copyToNewRow";
    ActionKey["deleteCell"] = "deleteCell";
    ActionKey["deleteRow"] = "deleteRow";
    ActionKey["markAsEssential"] = "markAsEssential";
    ActionKey["markAsNotEssential"] = "markAsNotEssential";
    ActionKey["updateCellComment"] = "updateCellComment";
    ActionKey["deleteCellComment"] = "deleteCellComment";
    ActionKey["removeActionRowListParam"] = "removeActionRowListParam";
    ActionKey["rewrite"] = "rewrite";
    ActionKey["rollback"] = "rollback";
    ActionKey["setEssential"] = "setEssential";
    ActionKey["undoSolver"] = "undoSolver";
    ActionKey["redoSolver"] = "redoSolver";
    ActionKey["updateCell"] = "updateCell";
    ActionKey["updateComment"] = "updateComment";
    ActionKey["updateGraphFunctions"] = "updateGraphFunctions";
    ActionKey["finishSubproblem"] = "finishSubproblem";
    ActionKey["editSubproblem"] = "editSubproblem";
    ActionKey["moveUpRow"] = "moveUpRow";
    ActionKey["moveDownRow"] = "moveDownRow";
    ActionKey["addSubproblemResult"] = "addSubproblemResult";
    ActionKey["updateSubproblemResult"] = "updateSubproblemResult";
    ActionKey["deleteSubproblemResult"] = "deleteSubproblemResult";
    ActionKey["addFinalAnswer"] = "addFinalAnswer";
    ActionKey["updateFinalAnswer"] = "updateFinalAnswer";
    ActionKey["deleteFinalAnswer"] = "deleteFinalAnswer";
    ActionKey["addFinalAnswerOptions"] = "addFinalAnswerOptions";
    ActionKey["addFinalAnswerMultipleChoice"] = "addFinalAnswerMultipleChoice";
    ActionKey["removeFinalAnswerMultipleChoice"] = "removeFinalAnswerMultipleChoice";
    ActionKey["addFunction"] = "addFunction";
    ActionKey["addFunctionToTable"] = "addFunctionToTable";
    ActionKey["addInterval"] = "addInterval";
    ActionKey["addIntervalToTable"] = "addIntervalToTable";
    ActionKey["addPoint"] = "addPoint";
    ActionKey["addPointToTable"] = "addPointToTable";
    ActionKey["addProperty"] = "addProperty";
    ActionKey["addTablePoints"] = "addTablePoints";
    ActionKey["addTablePropertiesFirstDerivative"] = "addTablePropertiesFirstDerivative";
    ActionKey["addTableProperties"] = "addTableProperties";
    ActionKey["addTablePropertiesSecondDerivative"] = "addTablePropertiesSecondDerivative";
    ActionKey["deleteFunction"] = "deleteFunction";
    ActionKey["deleteInterval"] = "deleteInterval";
    ActionKey["deletePoint"] = "deletePoint";
    ActionKey["deleteProperty"] = "deleteProperty";
    ActionKey["updateTableValue"] = "updateTableValue";
    ActionKey["addQuestionsRow"] = "addQuestionsRow";
    ActionKey["updateQuestionInput"] = "updateQuestionInput";
    ActionKey["submitQuestion"] = "submitQuestion";
    ActionKey["giveUpQuestion"] = "giveUpQuestion";
})(ActionKey || (ActionKey = {}));
export var ActionParameterKey;
(function (ActionParameterKey) {
    ActionParameterKey["rowId"] = "rowId";
    ActionParameterKey["type"] = "type";
    ActionParameterKey["tableEntityId"] = "tableEntityId";
    ActionParameterKey["parameterId"] = "parameterId";
    ActionParameterKey["cellId"] = "cellId";
    ActionParameterKey["value"] = "value";
    ActionParameterKey["insertAfter"] = "insertAfter";
    ActionParameterKey["finalAnswerId"] = "finalAnswerId";
    ActionParameterKey["finalAnswerOptionId"] = "finalAnswerOptionId";
    ActionParameterKey["finalAnswerPlaceholderId"] = "finalAnswerPlaceholderId";
    ActionParameterKey["finalAnswerPlaceholderOptionId"] = "finalAnswerPlaceholderOptionId";
    ActionParameterKey["finalAnswerPlaceholderOption"] = "finalAnswerPlaceholderOption";
    ActionParameterKey["updateHistory"] = "updateHistory";
    ActionParameterKey["questionsId"] = "questionsId";
    ActionParameterKey["questionIndex"] = "questionIndex";
    ActionParameterKey["inputId"] = "inputId";
    ActionParameterKey["questionsStepIndex"] = "questionsStepIndex";
    ActionParameterKey["lastShownQuestionIndex"] = "lastShownQuestionIndex";
})(ActionParameterKey || (ActionParameterKey = {}));
export var ActionResultType;
(function (ActionResultType) {
    ActionResultType["changes"] = "changes";
    ActionResultType["nochanges"] = "nochanges";
})(ActionResultType || (ActionResultType = {}));
export var ActionRowParameterType;
(function (ActionRowParameterType) {
    ActionRowParameterType["selection"] = "selection";
    ActionRowParameterType["input"] = "input";
    ActionRowParameterType["result"] = "result";
    ActionRowParameterType["equivalentResult"] = "equivalentResult";
})(ActionRowParameterType || (ActionRowParameterType = {}));
export var ActionTargetSource;
(function (ActionTargetSource) {
    ActionTargetSource["pd"] = "pd";
    ActionTargetSource["cell"] = "cell";
    ActionTargetSource["comment"] = "comment";
    ActionTargetSource["graphCell"] = "graphCell";
    ActionTargetSource["actionRow"] = "actionRow";
    ActionTargetSource["subproblem"] = "subproblem";
})(ActionTargetSource || (ActionTargetSource = {}));
export var ActionType;
(function (ActionType) {
    ActionType["local"] = "local";
    ActionType["math"] = "math";
})(ActionType || (ActionType = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["solo"] = "solo";
    ActivityType["tutor"] = "tutor";
    ActivityType["study"] = "study";
    ActivityType["problemSolving"] = "problemSolving";
})(ActivityType || (ActivityType = {}));
export var AnswerDefinitionType;
(function (AnswerDefinitionType) {
    AnswerDefinitionType["plain"] = "plain";
    AnswerDefinitionType["multipleChoice"] = "multipleChoice";
})(AnswerDefinitionType || (AnswerDefinitionType = {}));
export var AnswerTemplateOrder;
(function (AnswerTemplateOrder) {
    AnswerTemplateOrder["name"] = "name";
    AnswerTemplateOrder["type"] = "type";
})(AnswerTemplateOrder || (AnswerTemplateOrder = {}));
export var AssignmentAccessExceptionKey;
(function (AssignmentAccessExceptionKey) {
    AssignmentAccessExceptionKey["unavailableSection"] = "unavailableSection";
    AssignmentAccessExceptionKey["unpublished"] = "unpublished";
    AssignmentAccessExceptionKey["locked"] = "locked";
})(AssignmentAccessExceptionKey || (AssignmentAccessExceptionKey = {}));
export var AssignmentGradingSchema;
(function (AssignmentGradingSchema) {
    AssignmentGradingSchema["total_sum"] = "total_sum";
    AssignmentGradingSchema["normalized_sum"] = "normalized_sum";
})(AssignmentGradingSchema || (AssignmentGradingSchema = {}));
export var AssignmentTimerStatus;
(function (AssignmentTimerStatus) {
    AssignmentTimerStatus["notStarted"] = "notStarted";
    AssignmentTimerStatus["inProgress"] = "inProgress";
    AssignmentTimerStatus["over"] = "over";
    AssignmentTimerStatus["notSet"] = "notSet";
})(AssignmentTimerStatus || (AssignmentTimerStatus = {}));
export var AssignmentType;
(function (AssignmentType) {
    AssignmentType["practice"] = "practice";
    AssignmentType["guided"] = "guided";
    AssignmentType["assessment_multiple"] = "assessment_multiple";
    AssignmentType["assessment_once"] = "assessment_once";
    AssignmentType["custom"] = "custom";
})(AssignmentType || (AssignmentType = {}));
export var AssistStatus;
(function (AssistStatus) {
    AssistStatus["success"] = "success";
    AssistStatus["warning"] = "warning";
    AssistStatus["error"] = "error";
    AssistStatus["unknown"] = "unknown";
    AssistStatus["noproblem"] = "noproblem";
    AssistStatus["inprogress"] = "inprogress";
    AssistStatus["hint"] = "hint";
})(AssistStatus || (AssistStatus = {}));
export var BatchRenameModifier;
(function (BatchRenameModifier) {
    BatchRenameModifier["text"] = "text";
    BatchRenameModifier["sequenceNumber"] = "sequenceNumber";
})(BatchRenameModifier || (BatchRenameModifier = {}));
export var BehaviorTrackId;
(function (BehaviorTrackId) {
    BehaviorTrackId["actionSearch"] = "actionSearch";
    BehaviorTrackId["wysiwyg"] = "wysiwyg";
    BehaviorTrackId["fastAction"] = "fastAction";
    BehaviorTrackId["newRow"] = "newRow";
    BehaviorTrackId["copyExpression"] = "copyExpression";
    BehaviorTrackId["pasteExpression"] = "pasteExpression";
    BehaviorTrackId["assistPage"] = "assistPage";
    BehaviorTrackId["assistIcon"] = "assistIcon";
    BehaviorTrackId["assistRate"] = "assistRate";
    BehaviorTrackId["tutorialStart"] = "tutorialStart";
    BehaviorTrackId["tutorialFinish"] = "tutorialFinish";
    BehaviorTrackId["tutorialCarousel"] = "tutorialCarousel";
    BehaviorTrackId["tutorialVideoQuestionAnswer"] = "tutorialVideoQuestionAnswer";
    BehaviorTrackId["generatedProblemRate"] = "generatedProblemRate";
    BehaviorTrackId["transitionFromStudentDashboard"] = "transitionFromStudentDashboard";
    BehaviorTrackId["submitButtonClick"] = "submitButtonClick";
    BehaviorTrackId["interactiveTutorialSubmit"] = "interactiveTutorialSubmit";
    BehaviorTrackId["submitConfirmationCancel"] = "submitConfirmationCancel";
    BehaviorTrackId["submitConfirmationOkay"] = "submitConfirmationOkay";
})(BehaviorTrackId || (BehaviorTrackId = {}));
export var ColumnType;
(function (ColumnType) {
    ColumnType["STRING"] = "STRING";
    ColumnType["STRING_OR_LITERAL"] = "STRING_OR_LITERAL";
    ColumnType["NUMBER"] = "NUMBER";
    ColumnType["NUMBER_OR_STRING"] = "NUMBER_OR_STRING";
    ColumnType["BOOLEAN"] = "BOOLEAN";
    ColumnType["ARRAY"] = "ARRAY";
})(ColumnType || (ColumnType = {}));
export var ComputedIntervalStatus;
(function (ComputedIntervalStatus) {
    ComputedIntervalStatus["ok"] = "ok";
    ComputedIntervalStatus["invalid"] = "invalid";
})(ComputedIntervalStatus || (ComputedIntervalStatus = {}));
export var ComputedIntervalType;
(function (ComputedIntervalType) {
    ComputedIntervalType["open"] = "open";
    ComputedIntervalType["closed"] = "closed";
    ComputedIntervalType["left_closed"] = "left_closed";
    ComputedIntervalType["right_closed"] = "right_closed";
})(ComputedIntervalType || (ComputedIntervalType = {}));
export var ContentComplexity;
(function (ContentComplexity) {
    ContentComplexity["veryEasy"] = "veryEasy";
    ContentComplexity["easy"] = "easy";
    ContentComplexity["moderate"] = "moderate";
    ContentComplexity["hard"] = "hard";
    ContentComplexity["veryHard"] = "veryHard";
})(ContentComplexity || (ContentComplexity = {}));
export var ContentProviderOrder;
(function (ContentProviderOrder) {
    ContentProviderOrder["name"] = "name";
    ContentProviderOrder["relevance"] = "relevance";
})(ContentProviderOrder || (ContentProviderOrder = {}));
export var ContentStatus;
(function (ContentStatus) {
    ContentStatus["published"] = "published";
    ContentStatus["notPublished"] = "notPublished";
    ContentStatus["dirty"] = "dirty";
    ContentStatus["generated"] = "generated";
})(ContentStatus || (ContentStatus = {}));
export var ConversationFolderType;
(function (ConversationFolderType) {
    ConversationFolderType["inbox"] = "inbox";
    ConversationFolderType["archive"] = "archive";
})(ConversationFolderType || (ConversationFolderType = {}));
export var ConversationOrder;
(function (ConversationOrder) {
    ConversationOrder["time"] = "time";
})(ConversationOrder || (ConversationOrder = {}));
export var ConversationType;
(function (ConversationType) {
    ConversationType["text"] = "text";
    ConversationType["notifications"] = "notifications";
})(ConversationType || (ConversationType = {}));
export var CoreUserOrder;
(function (CoreUserOrder) {
    CoreUserOrder["name"] = "name";
    CoreUserOrder["email"] = "email";
    CoreUserOrder["relevance"] = "relevance";
    CoreUserOrder["lastLogin"] = "lastLogin";
})(CoreUserOrder || (CoreUserOrder = {}));
export var CoreUserProperties;
(function (CoreUserProperties) {
    CoreUserProperties["advancedSupervisorMode"] = "advancedSupervisorMode";
    CoreUserProperties["colorScheme"] = "colorScheme";
    CoreUserProperties["accessibleMath"] = "accessibleMath";
    CoreUserProperties["doNotShowAgainUserTimezone"] = "doNotShowAgainUserTimezone";
    CoreUserProperties["dontShowWelcome"] = "dontShowWelcome";
    CoreUserProperties["pdeLastContentProvider"] = "pdeLastContentProvider";
    CoreUserProperties["pdeLastPlainAnswerGradingMethod"] = "pdeLastPlainAnswerGradingMethod";
    CoreUserProperties["pdeLastMultipleChoiceAnswerGradingMethod"] = "pdeLastMultipleChoiceAnswerGradingMethod";
    CoreUserProperties["pdeLastAnswerType"] = "pdeLastAnswerType";
    CoreUserProperties["pdeLastMultipleChoiceSingle"] = "pdeLastMultipleChoiceSingle";
    CoreUserProperties["timeSpentVisibility"] = "timeSpentVisibility";
})(CoreUserProperties || (CoreUserProperties = {}));
export var CourseOrder;
(function (CourseOrder) {
    CourseOrder["name"] = "name";
    CourseOrder["lms"] = "lms";
    CourseOrder["id"] = "id";
    CourseOrder["date"] = "date";
    CourseOrder["status"] = "status";
    CourseOrder["relevance"] = "relevance";
    CourseOrder["lmsName"] = "lmsName";
})(CourseOrder || (CourseOrder = {}));
export var CoursePriceOrder;
(function (CoursePriceOrder) {
    CoursePriceOrder["course"] = "course";
    CoursePriceOrder["price"] = "price";
    CoursePriceOrder["status"] = "status";
    CoursePriceOrder["university"] = "university";
    CoursePriceOrder["relevance"] = "relevance";
})(CoursePriceOrder || (CoursePriceOrder = {}));
export var CourseStatus;
(function (CourseStatus) {
    CourseStatus["published"] = "published";
    CourseStatus["notPublished"] = "notPublished";
    CourseStatus["markedForArchive"] = "markedForArchive";
    CourseStatus["markedForUnarchive"] = "markedForUnarchive";
    CourseStatus["incomplete"] = "incomplete";
    CourseStatus["archived"] = "archived";
})(CourseStatus || (CourseStatus = {}));
export var CourseStatusFilter;
(function (CourseStatusFilter) {
    CourseStatusFilter["published"] = "published";
    CourseStatusFilter["notPublished"] = "notPublished";
    CourseStatusFilter["archived"] = "archived";
    CourseStatusFilter["opened"] = "opened";
})(CourseStatusFilter || (CourseStatusFilter = {}));
export var CourseUserOrder;
(function (CourseUserOrder) {
    CourseUserOrder["name"] = "name";
    CourseUserOrder["email"] = "email";
    CourseUserOrder["role"] = "role";
    CourseUserOrder["lastLogin"] = "lastLogin";
    CourseUserOrder["invitedAt"] = "invitedAt";
    CourseUserOrder["relevance"] = "relevance";
})(CourseUserOrder || (CourseUserOrder = {}));
export var CreateExerciseType;
(function (CreateExerciseType) {
    CreateExerciseType["instructions"] = "instructions";
    CreateExerciseType["single"] = "single";
    CreateExerciseType["pool"] = "pool";
})(CreateExerciseType || (CreateExerciseType = {}));
export var CustomListSpecialType;
(function (CustomListSpecialType) {
    CustomListSpecialType["custom"] = "custom";
    CustomListSpecialType["selected"] = "selected";
    CustomListSpecialType["practice"] = "practice";
    CustomListSpecialType["coursePractice"] = "coursePractice";
})(CustomListSpecialType || (CustomListSpecialType = {}));
export var CustomListType;
(function (CustomListType) {
    CustomListType["problem"] = "problem";
    CustomListType["template"] = "template";
})(CustomListType || (CustomListType = {}));
export var EmailConfirmationMode;
(function (EmailConfirmationMode) {
    EmailConfirmationMode["invitation"] = "invitation";
    EmailConfirmationMode["registration"] = "registration";
})(EmailConfirmationMode || (EmailConfirmationMode = {}));
export var EquivalenceSign;
(function (EquivalenceSign) {
    EquivalenceSign["equal"] = "equal";
    EquivalenceSign["arrow"] = "arrow";
    EquivalenceSign["approx"] = "approx";
    EquivalenceSign["greaterThan"] = "greaterThan";
    EquivalenceSign["lessThan"] = "lessThan";
    EquivalenceSign["greaterOrEqual"] = "greaterOrEqual";
    EquivalenceSign["lessOrEqual"] = "lessOrEqual";
    EquivalenceSign["notEqual"] = "notEqual";
})(EquivalenceSign || (EquivalenceSign = {}));
export var ExceptionKey;
(function (ExceptionKey) {
    ExceptionKey["INVALID_REQUEST"] = "INVALID_REQUEST";
    ExceptionKey["ACCESS_DENIED"] = "ACCESS_DENIED";
    ExceptionKey["REFERENCE_SOLUTION_USED_IN_ASSIGNMENT"] = "REFERENCE_SOLUTION_USED_IN_ASSIGNMENT";
    ExceptionKey["REF_SOLUTIONS_NOT_CRITICAL"] = "REF_SOLUTIONS_NOT_CRITICAL";
    ExceptionKey["SOLUTION_WAS_CHANGED_ELSEWHERE"] = "SOLUTION_WAS_CHANGED_ELSEWHERE";
    ExceptionKey["INTERSECTION_COMPUTATION_ERROR"] = "INTERSECTION_COMPUTATION_ERROR";
    ExceptionKey["KEY_NOT_ACTIVATED"] = "KEY_NOT_ACTIVATED";
    ExceptionKey["KEY_AUTOMATIC_GENERATION_DISABLED"] = "KEY_AUTOMATIC_GENERATION_DISABLED";
    ExceptionKey["ALREADY_HAVE_ACTIVATED_KEY"] = "ALREADY_HAVE_ACTIVATED_KEY";
    ExceptionKey["TUTORIAL_ERROR"] = "TUTORIAL_ERROR";
    ExceptionKey["ASSIGNMENT_TIMER_NOT_STARTED"] = "ASSIGNMENT_TIMER_NOT_STARTED";
    ExceptionKey["REGISTRATION_LOGIN_BUSY"] = "REGISTRATION_LOGIN_BUSY";
    ExceptionKey["REGISTRATION_UNDEF_LNAME"] = "REGISTRATION_UNDEF_LNAME";
    ExceptionKey["REGISTRATION_NAME_LENGTH"] = "REGISTRATION_NAME_LENGTH";
    ExceptionKey["REGISTRATION_UNDEF_FNAME"] = "REGISTRATION_UNDEF_FNAME";
    ExceptionKey["REGISTRATION_UNDEF_EMAIL"] = "REGISTRATION_UNDEF_EMAIL";
    ExceptionKey["REGISTRATION_INVALID_EMAIL"] = "REGISTRATION_INVALID_EMAIL";
})(ExceptionKey || (ExceptionKey = {}));
export var ExerciseInheritedField;
(function (ExerciseInheritedField) {
    ExerciseInheritedField["mode"] = "mode";
    ExerciseInheritedField["trials"] = "trials";
    ExerciseInheritedField["assignmentPoints"] = "assignmentPoints";
    ExerciseInheritedField["problemGradingSchema"] = "problemGradingSchema";
    ExerciseInheritedField["allowHints"] = "allowHints";
    ExerciseInheritedField["disabledActions"] = "disabledActions";
    ExerciseInheritedField["mathGradingMethod"] = "mathGradingMethod";
    ExerciseInheritedField["multipleChoiceGradingMethod"] = "multipleChoiceGradingMethod";
})(ExerciseInheritedField || (ExerciseInheritedField = {}));
export var ExerciseOrder;
(function (ExerciseOrder) {
    ExerciseOrder["name"] = "name";
    ExerciseOrder["indexNumber"] = "indexNumber";
    ExerciseOrder["problemName"] = "problemName";
    ExerciseOrder["attemptsUsed"] = "attemptsUsed";
    ExerciseOrder["score"] = "score";
    ExerciseOrder["progress"] = "progress";
    ExerciseOrder["lastSubmission"] = "lastSubmission";
})(ExerciseOrder || (ExerciseOrder = {}));
export var ExerciseType;
(function (ExerciseType) {
    ExerciseType["single"] = "single";
    ExerciseType["pool"] = "pool";
})(ExerciseType || (ExerciseType = {}));
export var ExportResultAssignmentScoreFormat;
(function (ExportResultAssignmentScoreFormat) {
    ExportResultAssignmentScoreFormat["total_sum"] = "total_sum";
    ExportResultAssignmentScoreFormat["normalized_sum"] = "normalized_sum";
})(ExportResultAssignmentScoreFormat || (ExportResultAssignmentScoreFormat = {}));
export var FinalAnswerType;
(function (FinalAnswerType) {
    FinalAnswerType["expressions"] = "expressions";
    FinalAnswerType["options"] = "options";
    FinalAnswerType["multipleChoice"] = "multipleChoice";
})(FinalAnswerType || (FinalAnswerType = {}));
export var GradingMethod;
(function (GradingMethod) {
    GradingMethod["CorrectIncorrect"] = "CorrectIncorrect";
    GradingMethod["RequireEssential"] = "RequireEssential";
    GradingMethod["CorrectOrEssential"] = "CorrectOrEssential";
    GradingMethod["MagicGrade"] = "MagicGrade";
    GradingMethod["PrecalculusReview"] = "PrecalculusReview";
    GradingMethod["ExactMatch"] = "ExactMatch";
    GradingMethod["dichotomous"] = "dichotomous";
    GradingMethod["balanced"] = "balanced";
    GradingMethod["morgan"] = "morgan";
    GradingMethod["ripkey"] = "ripkey";
    GradingMethod["weighted"] = "weighted";
})(GradingMethod || (GradingMethod = {}));
export var GraphFunctionsIntersectionStatus;
(function (GraphFunctionsIntersectionStatus) {
    GraphFunctionsIntersectionStatus["ok"] = "ok";
    GraphFunctionsIntersectionStatus["empty"] = "empty";
    GraphFunctionsIntersectionStatus["infinite"] = "infinite";
    GraphFunctionsIntersectionStatus["fail"] = "fail";
})(GraphFunctionsIntersectionStatus || (GraphFunctionsIntersectionStatus = {}));
export var GraphToolType;
(function (GraphToolType) {
    GraphToolType["graph"] = "graph";
    GraphToolType["sketchLine"] = "sketchLine";
})(GraphToolType || (GraphToolType = {}));
export var GroupColor;
(function (GroupColor) {
    GroupColor["blue"] = "blue";
    GroupColor["green"] = "green";
    GroupColor["grey"] = "grey";
    GroupColor["lightBlue"] = "lightBlue";
    GroupColor["orange"] = "orange";
    GroupColor["pink"] = "pink";
    GroupColor["red"] = "red";
    GroupColor["yellow"] = "yellow";
})(GroupColor || (GroupColor = {}));
export var LearningObjectiveRelevancy;
(function (LearningObjectiveRelevancy) {
    LearningObjectiveRelevancy["main"] = "main";
    LearningObjectiveRelevancy["medium"] = "medium";
})(LearningObjectiveRelevancy || (LearningObjectiveRelevancy = {}));
export var LearningProgressStatus;
(function (LearningProgressStatus) {
    LearningProgressStatus["notStarted"] = "notStarted";
    LearningProgressStatus["inProgress"] = "inProgress";
    LearningProgressStatus["onlyUnfinishedSolutions"] = "onlyUnfinishedSolutions";
    LearningProgressStatus["cantShowUntilDeadline"] = "cantShowUntilDeadline";
    LearningProgressStatus["done"] = "done";
    LearningProgressStatus["attemptsExceeded"] = "attemptsExceeded";
    LearningProgressStatus["pastDue"] = "pastDue";
    LearningProgressStatus["pastDueCanAddSolution"] = "pastDueCanAddSolution";
    LearningProgressStatus["pastDueCanAddSolutionWithoutGrade"] = "pastDueCanAddSolutionWithoutGrade";
    LearningProgressStatus["disabledByLti"] = "disabledByLti";
    LearningProgressStatus["timeOver"] = "timeOver";
})(LearningProgressStatus || (LearningProgressStatus = {}));
export var LicenseKeyOrder;
(function (LicenseKeyOrder) {
    LicenseKeyOrder["id"] = "id";
    LicenseKeyOrder["generationDate"] = "generationDate";
    LicenseKeyOrder["activationDate"] = "activationDate";
    LicenseKeyOrder["name"] = "name";
    LicenseKeyOrder["email"] = "email";
})(LicenseKeyOrder || (LicenseKeyOrder = {}));
export var LtiActivityAuthError;
(function (LtiActivityAuthError) {
    LtiActivityAuthError["problemNotFound"] = "problemNotFound";
    LtiActivityAuthError["templateNotFound"] = "templateNotFound";
    LtiActivityAuthError["activityTypeIsNotSet"] = "activityTypeIsNotSet";
    LtiActivityAuthError["problemOrTemplateIsNotSet"] = "problemOrTemplateIsNotSet";
    LtiActivityAuthError["studyRequiresTutorial"] = "studyRequiresTutorial";
    LtiActivityAuthError["attemptsExceeded"] = "attemptsExceeded";
    LtiActivityAuthError["referenceSolutionViewNotAllowed"] = "referenceSolutionViewNotAllowed";
    LtiActivityAuthError["referenceSolutionViewAfterSubmissions"] = "referenceSolutionViewAfterSubmissions";
})(LtiActivityAuthError || (LtiActivityAuthError = {}));
export var LtiAuthError;
(function (LtiAuthError) {
    LtiAuthError["invalidMessage"] = "invalidMessage";
    LtiAuthError["invalidConsumerKey"] = "invalidConsumerKey";
})(LtiAuthError || (LtiAuthError = {}));
export var LtiCourseAuthError;
(function (LtiCourseAuthError) {
    LtiCourseAuthError["liveModeRequired"] = "liveModeRequired";
    LtiCourseAuthError["multipleExternalTools"] = "multipleExternalTools";
    LtiCourseAuthError["roleNotSupported"] = "roleNotSupported";
    LtiCourseAuthError["assignmentLockedByInstructor"] = "assignmentLockedByInstructor";
    LtiCourseAuthError["assignmentNotConfigured"] = "assignmentNotConfigured";
    LtiCourseAuthError["licenseKeyNotAvailable"] = "licenseKeyNotAvailable";
    LtiCourseAuthError["licenseKeyDeactivated"] = "licenseKeyDeactivated";
})(LtiCourseAuthError || (LtiCourseAuthError = {}));
export var LtiResourceType;
(function (LtiResourceType) {
    LtiResourceType["assignment"] = "assignment";
    LtiResourceType["course"] = "course";
})(LtiResourceType || (LtiResourceType = {}));
export var MathActionType;
(function (MathActionType) {
    MathActionType["CALCULUS"] = "CALCULUS";
    MathActionType["MAGIC"] = "MAGIC";
    MathActionType["EQSOLVE"] = "EQSOLVE";
    MathActionType["ALGEBRA"] = "ALGEBRA";
    MathActionType["OTHER"] = "OTHER";
    MathActionType["BASICVECTORS"] = "BASICVECTORS";
    MathActionType["GRAPH"] = "GRAPH";
    MathActionType["REWRITING"] = "REWRITING";
    MathActionType["ORGANIZER"] = "ORGANIZER";
    MathActionType["SCIENCECALC"] = "SCIENCECALC";
    MathActionType["GRAPHINGCALC"] = "GRAPHINGCALC";
    MathActionType["CAS"] = "CAS";
})(MathActionType || (MathActionType = {}));
export var MathExpressionType;
(function (MathExpressionType) {
    MathExpressionType["ConstantBucket"] = "ConstantBucket";
    MathExpressionType["MathTerm"] = "MathTerm";
    MathExpressionType["Function"] = "Function";
    MathExpressionType["Equality"] = "Equality";
    MathExpressionType["Interval"] = "Interval";
    MathExpressionType["IntervalCombination"] = "IntervalCombination";
    MathExpressionType["Line"] = "Line";
    MathExpressionType["ExplicitVector"] = "ExplicitVector";
    MathExpressionType["GeneralTermSeq"] = "GeneralTermSeq";
    MathExpressionType["GeneralTermSeries"] = "GeneralTermSeries";
    MathExpressionType["Graph"] = "Graph";
    MathExpressionType["TableProperties"] = "TableProperties";
    MathExpressionType["Derivative"] = "Derivative";
    MathExpressionType["Integral"] = "Integral";
    MathExpressionType["Limit"] = "Limit";
    MathExpressionType["Equation"] = "Equation";
    MathExpressionType["Inequality"] = "Inequality";
    MathExpressionType["Point"] = "Point";
    MathExpressionType["Variable"] = "Variable";
    MathExpressionType["LinPolynomial"] = "LinPolynomial";
    MathExpressionType["Polynomial"] = "Polynomial";
    MathExpressionType["PowerSeries"] = "PowerSeries";
    MathExpressionType["Quotient"] = "Quotient";
    MathExpressionType["QuotientFunction"] = "QuotientFunction";
    MathExpressionType["RationalFunction"] = "RationalFunction";
    MathExpressionType["Integer"] = "Integer";
    MathExpressionType["Rational"] = "Rational";
    MathExpressionType["Sequence"] = "Sequence";
    MathExpressionType["Series"] = "Series";
    MathExpressionType["NumSeries"] = "NumSeries";
    MathExpressionType["PSet"] = "PSet";
    MathExpressionType["Set"] = "Set";
    MathExpressionType["Predicate"] = "Predicate";
    MathExpressionType["TablePoints"] = "TablePoints";
    MathExpressionType["VectorDerivative"] = "VectorDerivative";
    MathExpressionType["Undefined"] = "Undefined";
})(MathExpressionType || (MathExpressionType = {}));
export var MathLevel;
(function (MathLevel) {
    MathLevel["prealgebra"] = "prealgebra";
    MathLevel["algebra"] = "algebra";
    MathLevel["trigon"] = "trigon";
    MathLevel["precalc"] = "precalc";
    MathLevel["calc1"] = "calc1";
    MathLevel["calc2"] = "calc2";
    MathLevel["calc3"] = "calc3";
})(MathLevel || (MathLevel = {}));
export var MathMatchType;
(function (MathMatchType) {
    MathMatchType["algebra"] = "algebra";
    MathMatchType["calculus"] = "calculus";
    MathMatchType["exact"] = "exact";
})(MathMatchType || (MathMatchType = {}));
export var MathSelectionType;
(function (MathSelectionType) {
    MathSelectionType["pd"] = "pd";
    MathSelectionType["comment"] = "comment";
    MathSelectionType["cell"] = "cell";
})(MathSelectionType || (MathSelectionType = {}));
export var MessageSourceType;
(function (MessageSourceType) {
    MessageSourceType["activateReferenceSolutionRule"] = "activateReferenceSolutionRule";
    MessageSourceType["deactivateReferenceSolutionRule"] = "deactivateReferenceSolutionRule";
    MessageSourceType["moveExerciseRule"] = "moveExerciseRule";
    MessageSourceType["solvingTutorialsRule"] = "solvingTutorialsRule";
    MessageSourceType["welcomeMessageRule"] = "welcomeMessageRule";
    MessageSourceType["publishAssignmentRule"] = "publishAssignmentRule";
    MessageSourceType["changeDeadlineRule"] = "changeDeadlineRule";
    MessageSourceType["changePersonalDeadlineRule"] = "changePersonalDeadlineRule";
    MessageSourceType["changeNumberOfTrialsRule"] = "changeNumberOfTrialsRule";
    MessageSourceType["exerciseScoreUpdateRule"] = "exerciseScoreUpdateRule";
    MessageSourceType["instructorScoreUpdateRule"] = "instructorScoreUpdateRule";
    MessageSourceType["solutionChat"] = "solutionChat";
    MessageSourceType["exerciseProblemBroadcast"] = "exerciseProblemBroadcast";
    MessageSourceType["exerciseBroadcast"] = "exerciseBroadcast";
    MessageSourceType["assignmentBroadcast"] = "assignmentBroadcast";
    MessageSourceType["courseBroadcast"] = "courseBroadcast";
    MessageSourceType["scheduledPublishNotification"] = "scheduledPublishNotification";
    MessageSourceType["newsletter"] = "newsletter";
})(MessageSourceType || (MessageSourceType = {}));
export var OrderDirection;
(function (OrderDirection) {
    OrderDirection["asc"] = "asc";
    OrderDirection["desc"] = "desc";
})(OrderDirection || (OrderDirection = {}));
export var PaddleBillingType;
(function (PaddleBillingType) {
    PaddleBillingType["day"] = "day";
    PaddleBillingType["week"] = "week";
    PaddleBillingType["month"] = "month";
    PaddleBillingType["year"] = "year";
})(PaddleBillingType || (PaddleBillingType = {}));
export var PaddleHighRiskTransactionStatus;
(function (PaddleHighRiskTransactionStatus) {
    PaddleHighRiskTransactionStatus["accepted"] = "accepted";
    PaddleHighRiskTransactionStatus["rejected"] = "rejected";
    PaddleHighRiskTransactionStatus["pending"] = "pending";
})(PaddleHighRiskTransactionStatus || (PaddleHighRiskTransactionStatus = {}));
export var PaddleResourceType;
(function (PaddleResourceType) {
    PaddleResourceType["product"] = "product";
    PaddleResourceType["subscription"] = "subscription";
})(PaddleResourceType || (PaddleResourceType = {}));
export var PaddleSubscriptionStatus;
(function (PaddleSubscriptionStatus) {
    PaddleSubscriptionStatus["active"] = "active";
    PaddleSubscriptionStatus["trialing"] = "trialing";
    PaddleSubscriptionStatus["past_due"] = "past_due";
    PaddleSubscriptionStatus["paused"] = "paused";
    PaddleSubscriptionStatus["deleted"] = "deleted";
})(PaddleSubscriptionStatus || (PaddleSubscriptionStatus = {}));
export var PaddleWebhookType;
(function (PaddleWebhookType) {
    PaddleWebhookType["subscription_created"] = "subscription_created";
    PaddleWebhookType["subscription_payment_succeeded"] = "subscription_payment_succeeded";
    PaddleWebhookType["payment_succeeded"] = "payment_succeeded";
    PaddleWebhookType["subscription_cancelled"] = "subscription_cancelled";
    PaddleWebhookType["subscription_updated"] = "subscription_updated";
    PaddleWebhookType["high_risk_transaction_created"] = "high_risk_transaction_created";
    PaddleWebhookType["high_risk_transaction_updated"] = "high_risk_transaction_updated";
})(PaddleWebhookType || (PaddleWebhookType = {}));
export var PaymentOperation;
(function (PaymentOperation) {
    PaymentOperation["StripeCreate"] = "StripeCreate";
    PaymentOperation["StripeRetrieve"] = "StripeRetrieve";
    PaymentOperation["StripeCapture"] = "StripeCapture";
    PaymentOperation["StripeCardError"] = "StripeCardError";
    PaymentOperation["StripeError"] = "StripeError";
    PaymentOperation["PayPalCreate"] = "PayPalCreate";
    PaymentOperation["PayPalExecute"] = "PayPalExecute";
    PaymentOperation["PayPalCancel"] = "PayPalCancel";
    PaymentOperation["PayPalError"] = "PayPalError";
    PaymentOperation["PaddleSubscriptionPaymentSuccess"] = "PaddleSubscriptionPaymentSuccess";
    PaymentOperation["PaddleSubscriptionCreated"] = "PaddleSubscriptionCreated";
    PaymentOperation["PaddleSubscriptionCancelled"] = "PaddleSubscriptionCancelled";
    PaymentOperation["PaddleSubscriptionUpdated"] = "PaddleSubscriptionUpdated";
    PaymentOperation["PaddleOneTimePaymentSuccess"] = "PaddleOneTimePaymentSuccess";
    PaymentOperation["PaddleHighRiskTransactionUpdated"] = "PaddleHighRiskTransactionUpdated";
    PaymentOperation["PaddleHighRiskTransactionCreated"] = "PaddleHighRiskTransactionCreated";
})(PaymentOperation || (PaymentOperation = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["STRIPE"] = "STRIPE";
    PaymentType["PAYPAL"] = "PAYPAL";
    PaymentType["PADDLE"] = "PADDLE";
})(PaymentType || (PaymentType = {}));
export var PlaceholderType;
(function (PlaceholderType) {
    PlaceholderType["expression"] = "expression";
    PlaceholderType["options"] = "options";
})(PlaceholderType || (PlaceholderType = {}));
export var PreviewKeyType;
(function (PreviewKeyType) {
    PreviewKeyType["admin"] = "admin";
    PreviewKeyType["bugReport"] = "bugReport";
})(PreviewKeyType || (PreviewKeyType = {}));
export var ProblemChange;
(function (ProblemChange) {
    ProblemChange["name"] = "name";
    ProblemChange["content"] = "content";
    ProblemChange["complexity"] = "complexity";
    ProblemChange["tutorial"] = "tutorial";
    ProblemChange["expressions"] = "expressions";
    ProblemChange["lockedAnswerPlaceholderOptions"] = "lockedAnswerPlaceholderOptions";
    ProblemChange["lockedAnswerRequiredPlaceholder"] = "lockedAnswerRequiredPlaceholder";
    ProblemChange["lockedAnswerPlaceholdersNumber"] = "lockedAnswerPlaceholdersNumber";
    ProblemChange["answerPlaceholderExpressionType"] = "answerPlaceholderExpressionType";
    ProblemChange["additionalExpressions"] = "additionalExpressions";
    ProblemChange["answerType"] = "answerType";
    ProblemChange["answerGradingStrategy"] = "answerGradingStrategy";
    ProblemChange["answerPlaceholderType"] = "answerPlaceholderType";
    ProblemChange["answerPlaceholderContent"] = "answerPlaceholderContent";
    ProblemChange["answerContent"] = "answerContent";
    ProblemChange["comment"] = "comment";
    ProblemChange["learningObjective"] = "learningObjective";
    ProblemChange["disableNewRow"] = "disableNewRow";
    ProblemChange["primarySolution"] = "primarySolution";
})(ProblemChange || (ProblemChange = {}));
export var ProblemExpressionType;
(function (ProblemExpressionType) {
    ProblemExpressionType["definition"] = "definition";
    ProblemExpressionType["additional"] = "additional";
})(ProblemExpressionType || (ProblemExpressionType = {}));
export var ProblemGenerationType;
(function (ProblemGenerationType) {
    ProblemGenerationType["practice"] = "practice";
    ProblemGenerationType["preview"] = "preview";
    ProblemGenerationType["exercise"] = "exercise";
    ProblemGenerationType["activity"] = "activity";
})(ProblemGenerationType || (ProblemGenerationType = {}));
export var ProblemGradingSchema;
(function (ProblemGradingSchema) {
    ProblemGradingSchema["maximum"] = "maximum";
    ProblemGradingSchema["average"] = "average";
    ProblemGradingSchema["last_submission"] = "last_submission";
})(ProblemGradingSchema || (ProblemGradingSchema = {}));
export var ProblemNotReadyReason;
(function (ProblemNotReadyReason) {
    ProblemNotReadyReason["mainLearningObjectiveUndefined"] = "mainLearningObjectiveUndefined";
    ProblemNotReadyReason["grlException"] = "grlException";
    ProblemNotReadyReason["additionalGrlException"] = "additionalGrlException";
    ProblemNotReadyReason["optimalSolutionUndefined"] = "optimalSolutionUndefined";
    ProblemNotReadyReason["correctMultipleChoiceOptionUndefined"] = "correctMultipleChoiceOptionUndefined";
    ProblemNotReadyReason["multipleChoiceOptionIncorrect"] = "multipleChoiceOptionIncorrect";
    ProblemNotReadyReason["answerExpressionMissingPlaceholders"] = "answerExpressionMissingPlaceholders";
})(ProblemNotReadyReason || (ProblemNotReadyReason = {}));
export var ProblemOrder;
(function (ProblemOrder) {
    ProblemOrder["id"] = "id";
    ProblemOrder["contentProvider"] = "contentProvider";
    ProblemOrder["problem"] = "problem";
    ProblemOrder["complexity"] = "complexity";
    ProblemOrder["answer"] = "answer";
    ProblemOrder["author"] = "author";
    ProblemOrder["lastChangeAuthor"] = "lastChangeAuthor";
    ProblemOrder["relevance"] = "relevance";
})(ProblemOrder || (ProblemOrder = {}));
export var ProblemUpdateType;
(function (ProblemUpdateType) {
    ProblemUpdateType["updateExisting"] = "updateExisting";
    ProblemUpdateType["createNew"] = "createNew";
})(ProblemUpdateType || (ProblemUpdateType = {}));
export var ReferenceSolutionNotReadyReason;
(function (ReferenceSolutionNotReadyReason) {
    ReferenceSolutionNotReadyReason["solutionQualityInopportune"] = "solutionQualityInopportune";
    ReferenceSolutionNotReadyReason["solutionTypeInopportune"] = "solutionTypeInopportune";
    ReferenceSolutionNotReadyReason["solutionAnswerUndefined"] = "solutionAnswerUndefined";
    ReferenceSolutionNotReadyReason["solutionAnswerHaveNotContainAllRequirePlaceholder"] = "solutionAnswerHaveNotContainAllRequirePlaceholder";
    ReferenceSolutionNotReadyReason["solutionAnswersNotEquivalence"] = "solutionAnswersNotEquivalence";
    ReferenceSolutionNotReadyReason["solutionHasExpressionErrors"] = "solutionHasExpressionErrors";
    ReferenceSolutionNotReadyReason["solutionGraphHasExpressionErrors"] = "solutionGraphHasExpressionErrors";
    ReferenceSolutionNotReadyReason["problemHasInvalidDefinition"] = "problemHasInvalidDefinition";
})(ReferenceSolutionNotReadyReason || (ReferenceSolutionNotReadyReason = {}));
export var ReferenceSolutionQuality;
(function (ReferenceSolutionQuality) {
    ReferenceSolutionQuality["optimal"] = "optimal";
    ReferenceSolutionQuality["correct"] = "correct";
    ReferenceSolutionQuality["acceptable"] = "acceptable";
    ReferenceSolutionQuality["incorrect"] = "incorrect";
    ReferenceSolutionQuality["initial"] = "initial";
})(ReferenceSolutionQuality || (ReferenceSolutionQuality = {}));
export var ReferenceSolutionsOrder;
(function (ReferenceSolutionsOrder) {
    ReferenceSolutionsOrder["id"] = "id";
    ReferenceSolutionsOrder["name"] = "name";
    ReferenceSolutionsOrder["relevance"] = "relevance";
})(ReferenceSolutionsOrder || (ReferenceSolutionsOrder = {}));
export var ReportSource;
(function (ReportSource) {
    ReportSource["ASSIGNMENTS_REPORT"] = "ASSIGNMENTS_REPORT";
    ReportSource["STUDENTS_REPORT"] = "STUDENTS_REPORT";
    ReportSource["COURSES_REPORT"] = "COURSES_REPORT";
    ReportSource["EXERCISES_REPORT"] = "EXERCISES_REPORT";
})(ReportSource || (ReportSource = {}));
export var ResultExportDetailLevel;
(function (ResultExportDetailLevel) {
    ResultExportDetailLevel["assignments"] = "assignments";
    ResultExportDetailLevel["exercises"] = "exercises";
})(ResultExportDetailLevel || (ResultExportDetailLevel = {}));
export var RowType;
(function (RowType) {
    RowType["element"] = "element";
    RowType["comment"] = "comment";
    RowType["action"] = "action";
    RowType["subproblem"] = "subproblem";
    RowType["tablePoints"] = "tablePoints";
    RowType["tableProperties"] = "tableProperties";
    RowType["graph"] = "graph";
    RowType["questions"] = "questions";
    RowType["evaluation"] = "evaluation";
    RowType["answer"] = "answer";
})(RowType || (RowType = {}));
export var SandboxJobStatus;
(function (SandboxJobStatus) {
    SandboxJobStatus["queued"] = "queued";
    SandboxJobStatus["running"] = "running";
    SandboxJobStatus["completed"] = "completed";
    SandboxJobStatus["cancelled"] = "cancelled";
    SandboxJobStatus["failed"] = "failed";
})(SandboxJobStatus || (SandboxJobStatus = {}));
export var SandboxJobType;
(function (SandboxJobType) {
    SandboxJobType["serialize"] = "serialize";
    SandboxJobType["create"] = "create";
    SandboxJobType["clone"] = "clone";
    SandboxJobType["update"] = "update";
    SandboxJobType["regrade"] = "regrade";
    SandboxJobType["delete"] = "delete";
})(SandboxJobType || (SandboxJobType = {}));
export var SandboxUserOrder;
(function (SandboxUserOrder) {
    SandboxUserOrder["login"] = "login";
    SandboxUserOrder["name"] = "name";
    SandboxUserOrder["createdAt"] = "createdAt";
    SandboxUserOrder["acceptedAt"] = "acceptedAt";
    SandboxUserOrder["activatedAt"] = "activatedAt";
    SandboxUserOrder["relevance"] = "relevance";
})(SandboxUserOrder || (SandboxUserOrder = {}));
export var ScoreGroup;
(function (ScoreGroup) {
    ScoreGroup["successful"] = "successful";
    ScoreGroup["good"] = "good";
    ScoreGroup["satisfied"] = "satisfied";
    ScoreGroup["failed"] = "failed";
    ScoreGroup["inProgress"] = "inProgress";
    ScoreGroup["none"] = "none";
})(ScoreGroup || (ScoreGroup = {}));
export var SectionOrder;
(function (SectionOrder) {
    SectionOrder["name"] = "name";
})(SectionOrder || (SectionOrder = {}));
export var SectionRole;
(function (SectionRole) {
    SectionRole["instructor"] = "instructor";
    SectionRole["student"] = "student";
    SectionRole["teacherAssistant"] = "teacherAssistant";
    SectionRole["support"] = "support";
})(SectionRole || (SectionRole = {}));
export var SecuredAction;
(function (SecuredAction) {
    SecuredAction["create"] = "create";
    SecuredAction["edit"] = "edit";
    SecuredAction["view"] = "view";
    SecuredAction["remove"] = "remove";
    SecuredAction["configure"] = "configure";
    SecuredAction["solve"] = "solve";
    SecuredAction["importt"] = "importt";
    SecuredAction["export"] = "export";
    SecuredAction["regrade"] = "regrade";
    SecuredAction["ignore"] = "ignore";
    SecuredAction["consider"] = "consider";
    SecuredAction["updateStatus"] = "updateStatus";
    SecuredAction["exportResults"] = "exportResults";
    SecuredAction["share"] = "share";
    SecuredAction["impersonate"] = "impersonate";
    SecuredAction["licensedView"] = "licensedView";
    SecuredAction["extendDeadline"] = "extendDeadline";
    SecuredAction["addProblemToPool"] = "addProblemToPool";
})(SecuredAction || (SecuredAction = {}));
export var SecuredCase;
(function (SecuredCase) {
    SecuredCase["exercises"] = "exercises";
    SecuredCase["problems"] = "problems";
    SecuredCase["contents"] = "contents";
    SecuredCase["referenceSolutions"] = "referenceSolutions";
    SecuredCase["viewStudentScore"] = "viewStudentScore";
    SecuredCase["updateStudentScore"] = "updateStudentScore";
    SecuredCase["viewCourseStudent"] = "viewCourseStudent";
    SecuredCase["removeCourseStudent"] = "removeCourseStudent";
    SecuredCase["notifications"] = "notifications";
    SecuredCase["updateStatusCourse"] = "updateStatusCourse";
})(SecuredCase || (SecuredCase = {}));
export var SecuredEntity;
(function (SecuredEntity) {
    SecuredEntity["university"] = "university";
    SecuredEntity["user"] = "user";
    SecuredEntity["contentProvider"] = "contentProvider";
    SecuredEntity["license"] = "license";
    SecuredEntity["previewKey"] = "previewKey";
    SecuredEntity["system"] = "system";
    SecuredEntity["authSource"] = "authSource";
    SecuredEntity["courseUser"] = "courseUser";
    SecuredEntity["course"] = "course";
    SecuredEntity["assignmentGroup"] = "assignmentGroup";
    SecuredEntity["assignment"] = "assignment";
    SecuredEntity["exercise"] = "exercise";
    SecuredEntity["problem"] = "problem";
    SecuredEntity["template"] = "template";
    SecuredEntity["solution"] = "solution";
    SecuredEntity["exerciseSolution"] = "exerciseSolution";
    SecuredEntity["expertSolution"] = "expertSolution";
    SecuredEntity["gradingMethodSolution"] = "gradingMethodSolution";
    SecuredEntity["referenceSolution"] = "referenceSolution";
    SecuredEntity["practiceSolution"] = "practiceSolution";
    SecuredEntity["message"] = "message";
    SecuredEntity["score"] = "score";
    SecuredEntity["customList"] = "customList";
    SecuredEntity["securedCases"] = "securedCases";
    SecuredEntity["image"] = "image";
    SecuredEntity["report"] = "report";
    SecuredEntity["mathExpression"] = "mathExpression";
})(SecuredEntity || (SecuredEntity = {}));
export var SharingMode;
(function (SharingMode) {
    SharingMode["edit"] = "edit";
    SharingMode["read"] = "read";
})(SharingMode || (SharingMode = {}));
export var SolutionCellType;
(function (SolutionCellType) {
    SolutionCellType["expression"] = "expression";
    SolutionCellType["comment"] = "comment";
    SolutionCellType["tableProperties"] = "tableProperties";
    SolutionCellType["tablePoints"] = "tablePoints";
    SolutionCellType["graph"] = "graph";
})(SolutionCellType || (SolutionCellType = {}));
export var SolutionCloneResult;
(function (SolutionCloneResult) {
    SolutionCloneResult["created"] = "created";
    SolutionCloneResult["existed"] = "existed";
})(SolutionCloneResult || (SolutionCloneResult = {}));
export var SolutionDiffType;
(function (SolutionDiffType) {
    SolutionDiffType["CREATED"] = "CREATED";
    SolutionDiffType["UPDATED"] = "UPDATED";
    SolutionDiffType["REMOVED"] = "REMOVED";
    SolutionDiffType["WITHOUT_CHANGES"] = "WITHOUT_CHANGES";
})(SolutionDiffType || (SolutionDiffType = {}));
export var SolutionOrder;
(function (SolutionOrder) {
    SolutionOrder["id"] = "id";
    SolutionOrder["date"] = "date";
    SolutionOrder["score"] = "score";
    SolutionOrder["finished"] = "finished";
    SolutionOrder["author"] = "author";
    SolutionOrder["solvingTime"] = "solvingTime";
})(SolutionOrder || (SolutionOrder = {}));
export var SolutionScoreUpdateType;
(function (SolutionScoreUpdateType) {
    SolutionScoreUpdateType["manual"] = "manual";
    SolutionScoreUpdateType["auto"] = "auto";
    SolutionScoreUpdateType["undo"] = "undo";
})(SolutionScoreUpdateType || (SolutionScoreUpdateType = {}));
export var SolutionType;
(function (SolutionType) {
    SolutionType["exercise"] = "exercise";
    SolutionType["expert"] = "expert";
    SolutionType["reference"] = "reference";
    SolutionType["snapshot"] = "snapshot";
    SolutionType["practice"] = "practice";
    SolutionType["activity"] = "activity";
})(SolutionType || (SolutionType = {}));
export var SolvingMode;
(function (SolvingMode) {
    SolvingMode["exam"] = "exam";
    SolvingMode["tutorial"] = "tutorial";
    SolvingMode["interactiveTutorial"] = "interactiveTutorial";
    SolvingMode["vertical"] = "vertical";
})(SolvingMode || (SolvingMode = {}));
export var Status;
(function (Status) {
    Status["ok"] = "ok";
    Status["error"] = "error";
    Status["warning"] = "warning";
    Status["hint"] = "hint";
})(Status || (Status = {}));
export var StudentOrder;
(function (StudentOrder) {
    StudentOrder["name"] = "name";
    StudentOrder["email"] = "email";
    StudentOrder["score"] = "score";
    StudentOrder["exercise_problem_score"] = "exercise_problem_score";
    StudentOrder["solutions"] = "solutions";
    StudentOrder["completed_assignments"] = "completed_assignments";
    StudentOrder["completed_exercises"] = "completed_exercises";
    StudentOrder["lastLogin"] = "lastLogin";
    StudentOrder["assignment_time"] = "assignment_time";
    StudentOrder["exercise_problem_time"] = "exercise_problem_time";
    StudentOrder["start_time"] = "start_time";
    StudentOrder["course_time"] = "course_time";
    StudentOrder["course_progress"] = "course_progress";
    StudentOrder["assignment_progress"] = "assignment_progress";
    StudentOrder["invitedAt"] = "invitedAt";
    StudentOrder["relevance"] = "relevance";
    StudentOrder["assignment_last_submission"] = "assignment_last_submission";
    StudentOrder["exercise_last_submission"] = "exercise_last_submission";
})(StudentOrder || (StudentOrder = {}));
export var SubmissionAfterDeadline;
(function (SubmissionAfterDeadline) {
    SubmissionAfterDeadline["notAllow"] = "notAllow";
    SubmissionAfterDeadline["allowWithoutPenalty"] = "allowWithoutPenalty";
    SubmissionAfterDeadline["allowWithPenalty"] = "allowWithPenalty";
    SubmissionAfterDeadline["allowWithoutAffectingGrade"] = "allowWithoutAffectingGrade";
})(SubmissionAfterDeadline || (SubmissionAfterDeadline = {}));
export var TableIntervalType;
(function (TableIntervalType) {
    TableIntervalType["point"] = "point";
    TableIntervalType["interval"] = "interval";
})(TableIntervalType || (TableIntervalType = {}));
export var TablePropertiesType;
(function (TablePropertiesType) {
    TablePropertiesType["FIRST_DERIVATIVE"] = "FIRST_DERIVATIVE";
    TablePropertiesType["SECOND_DERIVATIVE"] = "SECOND_DERIVATIVE";
})(TablePropertiesType || (TablePropertiesType = {}));
export var TemplateOrder;
(function (TemplateOrder) {
    TemplateOrder["id"] = "id";
    TemplateOrder["template"] = "template";
    TemplateOrder["relevance"] = "relevance";
    TemplateOrder["author"] = "author";
    TemplateOrder["lastChangeAuthor"] = "lastChangeAuthor";
})(TemplateOrder || (TemplateOrder = {}));
export var TutorialProgressEvent;
(function (TutorialProgressEvent) {
    TutorialProgressEvent["start"] = "start";
    TutorialProgressEvent["end"] = "end";
    TutorialProgressEvent["goToStep"] = "goToStep";
    TutorialProgressEvent["answerToQuestion"] = "answerToQuestion";
    TutorialProgressEvent["tryAgainQuestion"] = "tryAgainQuestion";
    TutorialProgressEvent["giveUpQuestion"] = "giveUpQuestion";
    TutorialProgressEvent["cellSave"] = "cellSave";
    TutorialProgressEvent["cellEdit"] = "cellEdit";
    TutorialProgressEvent["cellSelect"] = "cellSelect";
    TutorialProgressEvent["videoStarted"] = "videoStarted";
    TutorialProgressEvent["videoEnded"] = "videoEnded";
    TutorialProgressEvent["videoClosed"] = "videoClosed";
})(TutorialProgressEvent || (TutorialProgressEvent = {}));
export var TutorialQuestionInputType;
(function (TutorialQuestionInputType) {
    TutorialQuestionInputType["expression"] = "expression";
    TutorialQuestionInputType["choice"] = "choice";
})(TutorialQuestionInputType || (TutorialQuestionInputType = {}));
export var TutorialSolverRowType;
(function (TutorialSolverRowType) {
    TutorialSolverRowType["comment"] = "comment";
    TutorialSolverRowType["expressions"] = "expressions";
})(TutorialSolverRowType || (TutorialSolverRowType = {}));
export var TutorialTableCellState;
(function (TutorialTableCellState) {
    TutorialTableCellState["button"] = "button";
    TutorialTableCellState["cell"] = "cell";
})(TutorialTableCellState || (TutorialTableCellState = {}));
export var TutorialTargetAssistSubtarget;
(function (TutorialTargetAssistSubtarget) {
    TutorialTargetAssistSubtarget["icon"] = "icon";
    TutorialTargetAssistSubtarget["area"] = "area";
})(TutorialTargetAssistSubtarget || (TutorialTargetAssistSubtarget = {}));
export var TutorialTargetChatSubtarget;
(function (TutorialTargetChatSubtarget) {
    TutorialTargetChatSubtarget["icon"] = "icon";
    TutorialTargetChatSubtarget["input"] = "input";
})(TutorialTargetChatSubtarget || (TutorialTargetChatSubtarget = {}));
export var TutorialTargetExpressionCellSubtarget;
(function (TutorialTargetExpressionCellSubtarget) {
    TutorialTargetExpressionCellSubtarget["btn"] = "btn";
    TutorialTargetExpressionCellSubtarget["actionResult"] = "actionResult";
})(TutorialTargetExpressionCellSubtarget || (TutorialTargetExpressionCellSubtarget = {}));
export var TutorialTargetType;
(function (TutorialTargetType) {
    TutorialTargetType["row"] = "row";
    TutorialTargetType["problemCell"] = "problemCell";
    TutorialTargetType["expressionCell"] = "expressionCell";
    TutorialTargetType["actionCell"] = "actionCell";
    TutorialTargetType["unique"] = "unique";
    TutorialTargetType["assist"] = "assist";
    TutorialTargetType["assistArea"] = "assistArea";
    TutorialTargetType["placeholder"] = "placeholder";
    TutorialTargetType["wysiwyg"] = "wysiwyg";
    TutorialTargetType["actions"] = "actions";
    TutorialTargetType["chat"] = "chat";
    TutorialTargetType["tableCell"] = "tableCell";
})(TutorialTargetType || (TutorialTargetType = {}));
export var TutorialTriggerType;
(function (TutorialTriggerType) {
    TutorialTriggerType["message"] = "message";
    TutorialTriggerType["selection"] = "selection";
    TutorialTriggerType["immediateAction"] = "immediateAction";
    TutorialTriggerType["action"] = "action";
    TutorialTriggerType["click"] = "click";
    TutorialTriggerType["cellAction"] = "cellAction";
    TutorialTriggerType["cellSave"] = "cellSave";
    TutorialTriggerType["cellEdit"] = "cellEdit";
    TutorialTriggerType["table"] = "table";
    TutorialTriggerType["freeSolve"] = "freeSolve";
    TutorialTriggerType["chatMessage"] = "chatMessage";
    TutorialTriggerType["video"] = "video";
    TutorialTriggerType["questions"] = "questions";
    TutorialTriggerType["addFinalAnswer"] = "addFinalAnswer";
    TutorialTriggerType["addRows"] = "addRows";
    TutorialTriggerType["rowMessage"] = "rowMessage";
    TutorialTriggerType["tableAddButtonClick"] = "tableAddButtonClick";
    TutorialTriggerType["showFinalAnswerRow"] = "showFinalAnswerRow";
    TutorialTriggerType["addFinalAnswerOption"] = "addFinalAnswerOption";
})(TutorialTriggerType || (TutorialTriggerType = {}));
export var UserActivationStatus;
(function (UserActivationStatus) {
    UserActivationStatus["notInvited"] = "notInvited";
    UserActivationStatus["notActivated"] = "notActivated";
    UserActivationStatus["onlyActivated"] = "onlyActivated";
    UserActivationStatus["active"] = "active";
})(UserActivationStatus || (UserActivationStatus = {}));
export var UserMessageNotificationInterval;
(function (UserMessageNotificationInterval) {
    UserMessageNotificationInterval["none"] = "none";
    UserMessageNotificationInterval["instant"] = "instant";
    UserMessageNotificationInterval["hour"] = "hour";
    UserMessageNotificationInterval["sixhours"] = "sixhours";
    UserMessageNotificationInterval["day"] = "day";
    UserMessageNotificationInterval["week"] = "week";
})(UserMessageNotificationInterval || (UserMessageNotificationInterval = {}));
export var UserPermissionLevel;
(function (UserPermissionLevel) {
    UserPermissionLevel["universityAdmin"] = "universityAdmin";
    UserPermissionLevel["supervisor"] = "supervisor";
    UserPermissionLevel["teacherAssistant"] = "teacherAssistant";
    UserPermissionLevel["support"] = "support";
    UserPermissionLevel["expert"] = "expert";
    UserPermissionLevel["student"] = "student";
    UserPermissionLevel["systemAdmin"] = "systemAdmin";
    UserPermissionLevel["sandboxAdmin"] = "sandboxAdmin";
    UserPermissionLevel["system"] = "system";
    UserPermissionLevel["licenseAdmin"] = "licenseAdmin";
    UserPermissionLevel["sharingManager"] = "sharingManager";
    UserPermissionLevel["sandbox"] = "sandbox";
})(UserPermissionLevel || (UserPermissionLevel = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["All"] = "All";
    UserStatus["Locked"] = "Locked";
    UserStatus["Unlocked"] = "Unlocked";
    UserStatus["Active"] = "Active";
    UserStatus["Inactive"] = "Inactive";
})(UserStatus || (UserStatus = {}));
export var UserTheme;
(function (UserTheme) {
    UserTheme["theme1"] = "theme1";
    UserTheme["theme2"] = "theme2";
    UserTheme["theme3"] = "theme3";
    UserTheme["theme4"] = "theme4";
    UserTheme["macs"] = "macs";
})(UserTheme || (UserTheme = {}));
export var ViewReferenceCondition;
(function (ViewReferenceCondition) {
    ViewReferenceCondition["never"] = "never";
    ViewReferenceCondition["always"] = "always";
    ViewReferenceCondition["nSubmission"] = "nSubmission";
    ViewReferenceCondition["lastSubmission"] = "lastSubmission";
    ViewReferenceCondition["deadline"] = "deadline";
})(ViewReferenceCondition || (ViewReferenceCondition = {}));
